import Http from './index.js';
import {
  getSession
} from "../storage";
import {
  // Loading,
  Message,
} from 'element-ui'
import Loading from 'toon-ui/lib/components/loading'

// 统一请求路径前缀
let base = window.$config && window.$config.host ? window.$config.host : null;
let axios = new Http(base, 45000);




axios.getInstance().defaults.headers.post['Content-Type'] = Http.ContentType.json;

var needLoadingRequestCount = 0 //当前正在请求的数量
/**
 * 请求拦截器
 */
axios.setRequestInterceptors(config => {
  Loading.open();
  // config.headers.token = $cookies.get('tokenDevService');
  /*config.headers.sessionId = sessionStorage.getItem('sessionId');*/
  needLoadingRequestCount++ //每次发送一个请求就进行++

  return config;
}, err => {
  Loading.close();
  Message.error('请求超时');
  return Promise.resolve(err);
})
/**
 * 响应拦截器
 */
axios.setResponseInterceptors(response => {
  // 处理业务问题

  needLoadingRequestCount-- //调用完一个接口就进行-1

  if (needLoadingRequestCount == 0) { //当接口都调用完时

    setTimeout(() => {

      Loading.close();

    }, 100)

  }

  return response.data;
}, err => {
  // 处理网络问题
  Loading.close();
  // Message.destroy();
  Message.error(err.message);
  return Promise.reject(err);
})


export const $http = axios.getInstance();

/**
 * 新项目将废弃以下方式 如项目中未使用可删除或忽略
 */
export const getRequest = axios.getRequest;
export const postRequest = axios.postRequest;
export const postRequestUrl = axios.postRequestUrl;